import jQuery from "jquery";
import { tns } from "tiny-slider/src/tiny-slider.js";
window.$ = window.jQuery = jQuery;

function equalizeCertificationHeights() {
    let maxHeight = 0;

    // Resetar antes de medir
    $(".carouselCertificacoes .certificacao").css("height", "auto");

    // Medir altura de TODOS os itens reais (exclui clones)
    $(".carouselCertificacoes .tns-item:not(.tns-cloned) .certificacao").each(
        function () {
            const h = $(this).outerHeight();
            if (h > maxHeight) {
                maxHeight = h;
            }
        }
    );

    // Aplicar altura a todos os itens reais
    $(".carouselCertificacoes .tns-item:not(.tns-cloned) .certificacao").css(
        "height",
        maxHeight + "px"
    );
}

let carouselCertificacoes = $(".carouselCertificacoes");
if (carouselCertificacoes.length > 0) {
    let slider = tns({
        container: ".carouselCertificacoes",
        items: 1,
        mouseDrag: true,
        controls: true,
        nav: false,
        loop: false,
        mouseDrag: true,
        touch: true,
        gutter: 20,
        controlsText: ["", ""],
        responsive: {
            640: {
                items: 1,
                gutter: 14,
                edgePadding: 120,
            },
            700: {
                items: 2,
                gutter: 24,
                edgePadding: 120,
            },
            900: {
                items: 3,
                gutter: 90,
                edgePadding: 0,
            },
        },
        onInit: equalizeCertificationHeights,
    });
}

let carouselSbp = $(".carouselSbp");
if (carouselSbp.length > 0) {
    let slider = tns({
        container: ".carouselSbp",
        items: 1,
        mouseDrag: true,
        controls: false,
        nav: false,
        loop: false,
        mouseDrag: true,
        touch: true,
        gutter: 20,
        controlsText: ["", ""],
        responsive: {
            640: {
                items: 1,
                gutter: 24,
                edgePadding: 120,
            },
            700: {
                items: 2,
                gutter: 24,
                edgePadding: 120,
            },
            900: {
                items: 3,
                gutter: 24,
                edgePadding: 0,
            },
        },
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const banner = document.querySelector(".video-banner");
    const container = document.getElementById("video-container");
    const title = document.getElementById("title");
    if (banner) {
        banner.addEventListener("click", function () {
            banner.style.display = "none";
            title.style.display = "none";

            let src = container.getAttribute("data-video");

            // Corrige autoplay na URL
            src = src.replace(/(&|\?)autoplay=\d/, "");
            const hasQuery = src.includes("?");
            src += hasQuery ? "&autoplay=1" : "?autoplay=1";

            // Cria o iframe
            const iframe = document.createElement("iframe");
            iframe.setAttribute("src", src);
            iframe.setAttribute(
                "allow",
                "autoplay; encrypted-media; fullscreen; picture-in-picture"
            );
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", ""); // precisa ser boolean
            iframe.className = "embed-responsive-item";
            iframe.style.width = "100%";
            iframe.style.height = "100%";

            container.appendChild(iframe);
        });
    }
});
